import React from "react";
import logo from "../assets/img/Aays.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SigninWidget.scss";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Overview from "../../pages/OverView/Overview";
import { loginRequest } from "./authConfig"; // make sure this points to your loginRequest

const Login = () => {
  const { instance } = useMsal(); // Access MSAL instance from context

  const login = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
      console.log("Login successful", loginResponse);
      const account = loginResponse && loginResponse.account;
      const idtoken = account && account.idToken;
      const userEmail =
        loginResponse && loginResponse?.idTokenClaims?.preferred_username;
      const userName = loginResponse && loginResponse?.idTokenClaims?.name;
      localStorage.setItem("userinfo", userEmail.toLowerCase());
      localStorage.setItem("userName", userName);
      localStorage.setItem(
        "access-token-storage",
        JSON.stringify({ accessToken: idtoken })
      );
    } catch (error) {
      console.error("Login failed", error);
    }
  };
  return (
    <>
      <AuthenticatedTemplate>
        <Overview />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="Buttons">
          <div className="loginPage">
            <div className="login_body_content">
              <div className="bg-white dark:bg-gray-900 bgColor">
                <div className="login_body_grid">
                  <div
                    // style={{ backgroundImage: `url(${bgimage})` }}
                    className="hidden bg-cover lg:block login_bg_image"
                  >
                    <div className="login_info">
                      <div className="text-container">
                        <img
                          style={{ width: "150px" }}
                          src={logo}
                          alt="Aays"
                          className="logo-img"
                        />
                        <div
                          style={{
                            display: "grid",
                            justifyContent: "center",
                          }}
                          className="text-4xl font-bold text-white"
                        >
                          <h1
                            style={{
                              fontSize: "30px",
                              width: "100%",
                              textAlign: "left",
                              lineHeight: "1.25",
                              marginBottom: "8px",
                              fontWeight: "600",
                            }}
                          >
                            AAYS AUDIT PLATFORM
                          </h1>
                        </div>

                        <p className="left_grid_text">
                          Welcome to the Aays Audit Platform . Access <br />
                          to this  system is limited{" "}
                          {/* <a
                            rel="noreferrer"
                            target={"_blank"}
                            href="mailto:anshuman.bhar@aaysanalytics.com"
                          >
                            anshuman.bhar@aaysanalytics.com
                          </a>{" "}
                          for details. */}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="right_grid_align">
                    <div className="blend"></div>

                    <div className="flex-1 right-container">
                      <div className="text-center">
                        <span className="text-4xl font-bold text-center text-gray-700 dark:text-white MarsLogo">
                          <img width={150} src={logo} alt="Aadi" />
                        </span>

                        <p className="signin-text">
                          Sign in to access your account
                        </p>
                      </div>

                      <div className="mt-[10px]">
                        <div className="mt-6">
                          <button className="btn_login" onClick={login}>
                            Sign in
                          </button>
                        </div>
                      </div>

                      <div
                        style={{
                          width: "70%",
                          paddingTop: "1.25rem",
                          display: "block",
                          margin: "auto",
                        }}
                      >
                        <span
                          id="Login_herf"
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <a
                            rel="noreferrer"
                            target={"_blank"}
                            className="loginText1 formLableText1"
                            style={{ textDecoration: "none" }}
                            href="mailto:anshuman.bhar@aaysanalytics.com?subject=Need Access to the Lab Analytics BI Portal - Pilot Applications!"
                          >
                            {" "}
                            Need Access?
                          </a>

                          <a
                            rel="noreferrer"
                            target={"_blank"}
                            className="loginText1 formLableText1"
                            style={{ textDecoration: "none" }}
                            href="mailto:anshuman.bhar@aaysanalytics.com?subject=Need Help On Sign in On Lab Analytics BI Portal - Pilot Applications!"
                          >
                            {" "}
                            Need Help?
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
};

export default Login;
